// extracted by mini-css-extract-plugin
module.exports = {"default":"Tab_default__xDcBU","selected":"Tab_selected__3GFNK"};